<script>
	import Country from '$lib/Components/Forms/Country/Country.svelte';
	import SuperForm from '$lib/Components/Forms/SuperForm/SuperForm.svelte';
	import SuperInput from '$lib/Components/Forms/SuperInput/SuperInput.svelte';
	import leadSchema from '$lib/PageSections/Forms/schemas/lead.schema.js';
	let {
		data = null,
		disabled = null,
		textString = true,
		class: className = '',
		leadFormData = $bindable(),
		buttonText = 'Request Estimate',
		action = '/forms/lead',
		requirePhone = false,
		requirePostalCode = false,
		requireFullName = false,
		text,
	} = $props();
</script>

<div>
	{#if textString}
		<p class="col-span-full mb-4 p-0 text-left text-sm text-indow-grey-dark!">
			{#if text}{@render text()}{:else}
				<span>
					To receive a customized estimate for your space or learn more about
					how Indow inserts can improve the comfort, quiet, & efficiency of your
					home, fill out the fields below.
				</span>
			{/if}
		</p>
	{/if}
	<SuperForm
		{data}
		{disabled}
		formName="lead"
		method="POST"
		sendPixelEvents
		schema={leadSchema}
		bind:innerForm={leadFormData}
		class={className}
		{action}
		{buttonText}
		buttonCenter
		defaultValues={{ country: 'United States' }}
	>
		{#snippet children({ form, disabled })}
			<SuperInput
				{form}
				{disabled}
				name="firstName"
				label="First Name"
				autocomplete="given-name"
				required={requireFullName}
			/>
			<SuperInput
				{form}
				{disabled}
				name="lastName"
				label="Last Name"
				autocomplete="family-name"
				required
			/>

			<SuperInput
				{form}
				{disabled}
				type="email"
				name="email"
				label="Email"
				autocomplete="email"
				class="col-span-full"
				required
			/>
			<SuperInput
				{form}
				{disabled}
				name="phone"
				type="tel"
				label="Phone"
				autocomplete="tel"
				phoneCountry="US"
				class="col-span-full"
				required={requirePhone}
			/>
			<SuperInput
				{form}
				{disabled}
				name="postalCode"
				type="text"
				label="Zip / Postal Code"
				autocomplete="postal-code"
				required={requirePostalCode}
			/>
			<Country {form} {disabled} name="country" label="Country" />
			<div class="col-span-full mb-4 grid gap-2">
				<p class="col-span-full mb-0 w-full p-0 text-left">
					What issues are you experiencing?
				</p>

				<div
					class="
       col-span-full mb-4 grid grid-flow-dense
       grid-cols-[repeat(auto-fit,minmax(max(30%,9rem),1fr))] gap-4
     "
				>
					<SuperInput
						{form}
						{disabled}
						name="focusTemperature"
						type="checkbox"
						label="Temperature loss"
						class="col-span-1!"
					/>
					<SuperInput
						{form}
						{disabled}
						name="focusSound"
						type="checkbox"
						label="Loud noises"
						class="col-span-1!"
					/>
					<SuperInput
						{form}
						{disabled}
						name="focusUV"
						type="checkbox"
						label="UV Damage"
						class="col-span-1!"
					/>
					<SuperInput
						{form}
						{disabled}
						name="focusEnergy"
						type="checkbox"
						label="High energy use"
						class="col-span-1!"
					/>
					<SuperInput
						{form}
						{disabled}
						name="focusOther"
						type="checkbox"
						label="Other"
						class="col-span-1!"
					/>
				</div>
			</div>
			<SuperInput
				{form}
				{disabled}
				name="notes"
				type="textarea"
				label="(Optional) For a faster response, include the number of windows you'd like to insulate and approximate window dimensions (rounded up to the next inch) for each window:"
				class="col-span-full"
			/>
		{/snippet}
	</SuperForm>
</div>
